export const styles = {
	mainContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: '20px',
		width: '100%'
	},
	heading: {
		fontSize: '24px',
		fontWeight: 'bold',
		color: '#333',
		marginBottom: '10px'
	},
	contentContainer: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'flex-start',
		width: '100%'
	},
	section: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		padding: '15px',
		backgroundColor: '#f8f9fa',
		borderRadius: '4px',
		height: '100px'
	},
	kycDetailsLabel: {
		fontWeight: 'bold',
		fontSize: '16px',
		marginRight: '10px'
	},
	kycDetailsValue: {
		color: '#333',
		fontSize: '14px'
	},
	buttonContainer: {
		display: 'flex',
		alignItems: 'flex-end',
		padding: '15px'
	},
	button: {
		padding: '8px 16px',
		backgroundColor: '#007bff',
		color: 'white',
		border: 'none',
		borderRadius: '4px',
		cursor: 'pointer',
		':hover': {
			backgroundColor: '#0056b3'
		}
	}
};
